/**
 * Created by f on 2018/5/22.
 */
import { chunk, clone, filter, forEach, keys, map, round, sum } from 'lodash-es';
import moment from 'moment';
import qs from 'qs';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import tmsServiceToFormData from '../../services/axios/tmsServiceToFormData';
import { analytics } from '../../services/analytics';
import switchBillingToService from '../../shared/switchBillingToService';
import template from './batchImport.vue';
@Component({
    mixins: [template],
    name: 'batchImport',
    components: { UinsDefaultSelect },
})
export default class BatchImport extends Vue {
    @Prop({
        default:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/pdf,application/msword',
    })
    accept!: string;

    @Prop({ default: false })
    show!: boolean;
    options: any = {};
    isLoading: boolean = false;
    isBatchImport: boolean = false;
    isImage: boolean = false;
    files: Array<any> = [];
    fd: any = null;
    formdata: any = null;
    imgs: Array<any> = [];
    file: any = {};
    isDisabled: boolean = true;
    message: any = {};
    fileName: any = '';
    billto_id: any = '';
    company_id: any = '';
    user_id: any = '';
    errorOrders: any = '';
    tableHeads: any = '';
    noFileSmg: any = '';
    version: any = '';

    @Watch('show')
    isErrorshow() {
        let tim: any;
        if (this.show) {
        }
        if (!this.show) clearTimeout(tim);
    }

    @Watch('options', { deep: true })
    getValue(val: any, oldVal: any) {
        if (val.order_id) {
        }
    }

    mounted() {
        this.getCustomerData();
        let dropbox: any = document.querySelector('.dropbox');
        dropbox.addEventListener('dragenter', this.onDrag, false);
        dropbox.addEventListener('dragover', this.onDrag, false);
        dropbox.addEventListener('drop', this.onDrop, false);
    }

    private async getCustomerData() {
        await switchBillingToService
            .post()
            .then((res: any) => {
                if (res.data.billing != undefined && res.data.billing.location_id) {
                    this.billto_id = res.data.billing.location_id;
                }
                if (res.data.user) {
                    this.company_id = res.data.user.company_id;
                    this.user_id = res.data.user.user_id;
                }
            })
            .catch(error => {});
    }

    addImg() {
        let inputDOM: any = this.$refs.inputer;
        forEach(inputDOM.files, (item: any) => {
            if (item.type.indexOf('image') > -1) this.isImage = true;
            this.uploadFile(item);
        });
    }

    uploadFile(file: any) {
        this.fileName = clone(file.name);
        this.file = file;
        this.formdata = new FormData();
        this.formdata.append('file', file);
        this.formdata.append('billto_id', this.billto_id);
        this.formdata.append('company_id', this.company_id);
        this.formdata.append('user_id', this.user_id);
        this.noFileSmg = '';
        this.isDisabled = false;
        this.$forceUpdate();
        this.importExcel('');
    }

    onDrag(e: any) {
        e.stopPropagation();
        e.preventDefault();
    }

    onDrop(e: any) {
        e.stopPropagation();
        e.preventDefault();
        let dt = e.dataTransfer;
        forEach(dt.files, item => this.uploadFile(item));
    }

    quoteData: any = [];
    shipperData: any = [];
    quoteDataHead: any = [];
    isCreateQuote: boolean = false;
    isSelectAll: boolean = false;
    selectAllShipperData: any = [];
    successOrders: any = [];
    canQuoteData: any = [];
    total: number = 0.0;
    totalString: string = '0.00';
    importErrors: any = [];

    async createOrder(event: any) {
        this.isBatchImport = true;

        this.version = this.selectAllShipperData[0].version;
        let segmentationData = chunk(this.selectAllShipperData, 10);
        let promiseAll: any = [];
        forEach(segmentationData, (item: any) => {
            promiseAll.push(this.combiningData(item));
        });
        await Promise.all(promiseAll);
        this.quoteData = [];
        this.getOrderImportLog();
        this.isBatchImport = false;
    }

    importExcel(event: any) {
        if (!this.formdata) {
            this.noFileSmg = 'Please select the file to upload';

            return;
        }
        this.quoteData = [];
        this.errorOrders = [];
        this.successOrders = [];
        this.isCreateQuote = true;
        tmsServiceToFormData.post(`/excel/order/importExcel`, this.formdata).then(
            async (res: any) => {
                this.formdata = null;
                if (res.data) {
                    this.formdata = null;
                    this.fileName = '';
                    let resData = res.data;
                    for (let i = 0; i < resData.length; i++) {
                        if (resData[i]['excel_import_status'] != '-1') {
                            if (resData[i]['Weight_1']) {
                                resData[i]['Weight'] =
                                    Number(resData[i]['Weight_1']) +
                                    (Number(resData[i]['Weight_2'])
                                        ? Number(resData[i]['Weight_2'])
                                        : 0);
                            }
                            if (resData[i]['Pickup Date(e.g. 07/10/2023)']) {
                                resData[i]['appointment_date'] = moment(
                                    resData[i]['Pickup Date(e.g. 07/10/2023)']
                                ).format('YYYY-MM-DD');
                                resData[i]['Pickup Date(e.g. 07/10/2023)'] = moment(
                                    resData[i]['Pickup Date(e.g. 07/10/2023)']
                                ).format('YYYY-MM-DD');
                            }
                            if (resData[i]['Earliest Pickup Time(e.g. 9:00)']) {
                                resData[i]['appointment_time'] = moment(
                                    resData[i]['Earliest Pickup Time(e.g. 9:00)'],
                                    ['h:mm:ss']
                                ).format('HH:mm:ss');
                                resData[i]['Earliest Pickup Time(e.g. 9:00)'] = moment(
                                    resData[i]['Earliest Pickup Time(e.g. 9:00)'],
                                    ['h:mm:ss']
                                ).format('HH:mm:ss');
                            }
                            if (resData[i]['Latest Pickup Time(e.g. 16:00)']) {
                                resData[i]['appointment_time_to'] = moment(
                                    resData[i]['Latest Pickup Time(e.g. 16:00)'],
                                    ['h:mm:ss']
                                ).format('HH:mm:ss');
                                resData[i]['Latest Pickup Time(e.g. 16:00)'] = moment(
                                    resData[i]['Latest Pickup Time(e.g. 16:00)'],
                                    ['h:mm:ss']
                                ).format('HH:mm:ss');
                            }
                            let postData = this.postData(resData[i]);
                            try {
                                await tmsServiceBackend
                                    .post('quote/tmsMileService', qs.stringify(postData))
                                    .then(async (response: any) => {
                                        if (
                                            response.data.data &&
                                            response.data.data['quote_amount']
                                        ) {
                                            resData[i].quote_amount =
                                                response.data.data['quote_amount'];
                                            resData[i].numberQuoteAmount = Number(
                                                response.data.data['quote_amount']
                                            );
                                            resData[i].quote_id = response.data.data['quote_id'];
                                        }
                                        if (
                                            response.data &&
                                            response.data.message &&
                                            response.data.message != 'Success'
                                        ) {
                                            resData[i].errMessage = response.data.message;
                                        }
                                        this.quoteData.push(resData[i]);
                                        this.$forceUpdate();
                                    })
                                    .catch(err => {});
                            } catch (err) {}
                        }
                    }
                    this.isCreateQuote = false;
                    this.quoteData = resData;
                    this.filtterShipperData(resData);
                }
            },
            (err: any) => {
                this.err('User switching error');
            }
        );
    }

    filtterShipperData(data: any) {
        this.canQuoteData = filter(data, 'quote_id');
    }

    selectAll() {
        forEach(this.quoteData, (item: any) => {
            if (item.quote_id) {
                if (this.isSelectAll) {
                    item.isChecked = true;
                } else {
                    item.isChecked = false;
                }
            }
        });
        this.selectAllShipperData = filter(this.quoteData, 'isChecked');
        this.total = round(sum(map(this.selectAllShipperData, 'numberQuoteAmount')), 2);
        if (Math.floor(this.total) === this.total) {
            this.totalString = this.total.toString() + '.00';
        } else {
            this.totalString = this.total.toString();
        }
    }

    selectShipper(item: any) {
        if (item.isChecked) {
            item.isChecked = false;
        } else {
            item.isChecked = true;
        }
        this.selectAllShipperData = filter(this.quoteData, 'isChecked');
        this.total = round(sum(map(this.selectAllShipperData, 'numberQuoteAmount')), 2);
        if (Math.floor(this.total) === this.total) {
            this.totalString = this.total.toString() + '.00';
        } else {
            this.totalString = this.total.toString();
        }
        if (this.isCreateQuote) {
            return;
        }
        if (this.selectAllShipperData.length == this.canQuoteData.length) {
            this.isSelectAll = true;
        } else {
            this.isSelectAll = false;
        }
    }

    postData(data: any) {
        let caertQu: any = {
            UserID: localStorage.getItem('UserID'),
            UserToken: localStorage.getItem('UserToken'),
            input_batch: 0,
            input_billing_party: 1,
            total_freight_value: '',
            input_billto_id: this.billto_id,
            input_consignee_city: data['Consignee City'],
            input_consignee_contact: '',
            input_consignee_id: '',
            input_consignee_name: data['Consignee Name'],
            input_consignee_phone: data['Consignee Phone'],
            input_consignee_state: data['Consignee State'],
            input_consignee_street: data['Consignee Street'],
            input_consignee_warehouse: '',
            input_consignee_zip: data['Consignee Zipcode'],
            input_debug: 0,
            input_dray_manifest_id: 0,
            input_drayage_port: 0,
            input_equipment_type: 0,
            input_internal_notes: '',
            input_mastertariff_id: 0,
            input_notes: '',
            input_quote_expiration_date: '',
            input_quote_id: '',
            input_savequote: 1,
            input_shipby: 0,
            input_shipment_date: data['Pickup Date'],
            input_shipment_id: 0,
            input_shipper_city: data['Shipper City'],
            input_shipper_contact: '',
            input_shipper_id: '',
            input_shipper_name: '',
            input_shipper_phone: data['Shipper Phone'],
            input_shipper_state: data['Shipper State'],
            input_shipper_street: data['Shipper Street'],
            input_shipper_warehouse: '',
            input_shipper_zip: data['Shipper Zipcode'],
            input_single: 1,
            input_trip_id: 0,
            input_value: '',
            input_shipper_address_type: 'zipcode',
            input_consignee_address_type: 'zipcode',
            input_shipper_wise_facility_id: '',
            input_consignee_wise_facility_id: '',
            input_pickup_location_type: '',
            input_delivery_location_type: '',
        };
        let manifestLines: any = [];
        if (data['Accessorial Code']) {
            manifestLines.push({
                manifest_product_id: '',
                manifest_pallet_dimension_id: '',
                manifest_carton: '',
                manifest_class: '',
                manifest_code: data['Accessorial Code'],
                manifest_code_id: '',
                manifest_content: '',
                manifest_line_id: '',
                manifest_linear: '',
                manifest_pallet: '',
                manifest_space: '',
                manifest_value: '',
                manifest_volume: '',
                manifest_weight: '',
                save_product: false,
                volume_details: [
                    {
                        palletType: '',
                        width: '',
                        length: '',
                        height: '',
                        isStackable: false,
                    },
                ],
            });
        }
        if (data['Accessorial Code2']) {
            manifestLines.push({
                manifest_product_id: '',
                manifest_pallet_dimension_id: '',
                manifest_carton: '',
                manifest_class: '',
                manifest_code: data['Accessorial Code2'],
                manifest_code_id: '',
                manifest_content: '',
                manifest_line_id: '',
                manifest_linear: '',
                manifest_pallet: '',
                manifest_space: '',
                manifest_value: '',
                manifest_volume: '',
                manifest_weight: '',
                save_product: false,
                volume_details: [
                    {
                        palletType: '',
                        width: '',
                        length: '',
                        height: '',
                        isStackable: false,
                    },
                ],
            });
        }
        if (data['Accessorial Code3']) {
            manifestLines.push({
                manifest_product_id: '',
                manifest_pallet_dimension_id: '',
                manifest_carton: '',
                manifest_class: '',
                manifest_code: data['Accessorial Code3'],
                manifest_code_id: '',
                manifest_content: '',
                manifest_line_id: '',
                manifest_linear: '',
                manifest_pallet: '',
                manifest_space: '',
                manifest_value: '',
                manifest_volume: '',
                manifest_weight: '',
                save_product: false,
                volume_details: [
                    {
                        palletType: '',
                        width: '',
                        length: '',
                        height: '',
                        isStackable: false,
                    },
                ],
            });
        }
        if (data['Piece_1']) {
            manifestLines.push({
                manifest_product_id: '',
                manifest_pallet_dimension_id: '',
                manifest_carton: data['Piece_1'],
                manifest_class: data['Class_1'],
                manifest_code: '',
                manifest_code_id: '',
                manifest_content: '',
                manifest_line_id: '',
                manifest_linear: '',
                manifest_pallet: data['Pallet_1'],
                manifest_space: '',
                manifest_value: '',
                manifest_volume: '',
                manifest_weight: data['Weight_1'],
                save_product: false,
                volume_details: [
                    {
                        palletType: '',
                        width: '',
                        length: '',
                        height: '',
                        isStackable: false,
                    },
                ],
            });
        }
        if (data['Piece_2']) {
            manifestLines.push({
                manifest_product_id: '',
                manifest_pallet_dimension_id: '',
                manifest_carton: data['Piece_2'],
                manifest_class: data['Class_2'],
                manifest_code: '',
                manifest_code_id: '',
                manifest_content: '',
                manifest_line_id: '',
                manifest_linear: '',
                manifest_pallet: data['Pallet_2'],
                manifest_space: '',
                manifest_value: '',
                manifest_volume: '',
                manifest_weight: data['Weight_2'],
                save_product: false,
                volume_details: [
                    {
                        palletType: '',
                        width: '',
                        length: '',
                        height: '',
                        isStackable: false,
                    },
                ],
            });
        }
        this.$set(caertQu, 'manifest_lines', manifestLines);
        return caertQu;
    }

    OrderImportLog: any = '';
    getOrderImportLog() {
        let params = {
            company_id: this.company_id,
            user_id: this.user_id,
            version: this.version,
        };
        tmsServiceBackend.post(`/order/getOrderImportLog`, params).then(
            (res: any) => {
                if (res.data) {
                    this.isBatchImport = false;
                    this.selectAllShipperData = [];
                    this.tableHeads = keys(res.data.data[0]);
                    this.errorOrders = filter(filter(res.data.data, { order_id: null }), 'desc');
                    if (this.errorOrders.length < 1) {
                        this.successBtn();
                    }
                }
            },
            (err: any) => {
                this.selectAllShipperData = [];
                this.isBatchImport = false;
                this.err('User switching error');
            }
        );
    }

    combiningData(data: any) {
        let params = {
            billto_id: this.billto_id,
            company_id: this.company_id,
            user_id: this.user_id,
            data: data,
        };
        return new Promise((resolve, reject) => {
            tmsServiceBackend.post(`/excel/order/createOrder`, params).then(
                (res: any) => {
                    resolve('success');
                },
                (err: any) => {
                    reject('err');
                }
            );
        });
    }

    successBtn() {
        this.show = false;
        let node = document.querySelector('.batchImport');
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }

    cancelBtn(): void {
        this.show = false;
        let node = document.querySelector('.batchImport');
        if (node && node.parentNode) {
            node.parentNode.removeChild(node);
        }
    }
    downloadTemplate(): void {
        let a = document.createElement('a');
        a.href = `${window.location.origin}/apinew/excel/order/getOrderImportTemplateFile`;
        document.body.appendChild(a);
        a.style.display = 'none';
        a.download = 'Client Portal Order Template';
        a.click();
        analytics.trackFileDownload({ fileName: 'order_import_template', fileType: 'xlsx' });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/components/batchImport/index.ts